import React from "react";
import { gridClasses } from "@mui/x-data-grid";
import MzDataGrid from "@markaaz/ui/MzDataGrid";

const sx = {
  datagrid: {
    width: "480px",
    "& .MuiDataGrid-cell": {
      padding: "12px 20px 12px 20px",
      borderRight: (theme) => `1px solid ${theme.palette.blue.c20}`
    },
    "& .MuiDataGrid-cell:last-child": {
      borderRight: "none"
    },
    "& .MuiDataGrid-columnHeaders": {
      border: "none"
    },
    "& .MuiDataGrid-columnHeader": {
      padding: 0,
      borderRight: (theme) => `1px solid ${theme.palette.common.white}`
    },
    "& .MuiDataGrid-columnHeader:last-child": {
      borderRight: "none"
    },
    "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
      borderBottom: "none"
    },
    "& .MuiDataGrid-row:last-child": {
      borderBottomLeftRadius: "8px",
      borderBottomRightRadius: "8px"
    },
    "& .MuiDataGrid-columnHeaderTitle": (theme) => {
      return { ...theme.typography.overline1, padding: "10px 20px" };
    },
    [`.${gridClasses.row}:hover`]: {
      backgroundColor: "common.white"
    },
    "& .MuiDataGrid-virtualScroller": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "10px",
        height: "10px",
        backgroundColor: (theme) => `${theme.palette.common.white}`,
        borderRadius: "0px 0px 8px 8px"
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: (theme) => `${theme.palette.darkBlue.c20}`,
        borderRadius: "8px"
      }
    }
  }
};

export default function CheckGrid({ rows, columns }) {
  return (
    rows !== undefined && (
      <MzDataGrid
        rowHeight={44}
        headerHeight={36}
        sx={sx.datagrid}
        variant="3"
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        hideFooterPagination
        hideFooter={true}
        disableColumnMenu={true}
        showCellRightBorder={true}
      />
    )
  );
}
